import { useTranslation } from 'react-i18next';

// AssignmentGapDivider marks that an assignment the viewer may not see sits between two rows.
// Deliberately carries no count or company name.
export function AssignmentGapDivider() {
  const { t } = useTranslation();

  return (
    <div className="text-muted flex items-center gap-3 pl-10 text-xs" role="separator">
      <span className="border-border flex-1 border-t border-dashed" />
      <span>{t('devices.detail.assignment.gap')}</span>
      <span className="border-border flex-1 border-t border-dashed" />
    </div>
  );
}
